export default __webpack_public_path__ + "static/media/logo-icon.b8047168.svg";